import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { ReporteService } from "src/app/services/reportes/reporte.service";
import { MatDialogRef } from "@angular/material";
import { ProspectsService } from "src/app/services/prospects/prospects.service";
import { Prospect } from "src/app/models/prospects";
import { map, startWith } from "rxjs/operators";
import { UserService } from "src/app/services/users/user.service";
import { UserData } from "src/app/models/user";
import { AuthService } from "src/app/services/authFirebase/auth.service";
import { BillingService } from "src/app/services/billing/billing.service";
import { log } from "console";

@Component({
  selector: "app-generate-general-report",
  templateUrl: "./generate-general-report.component.html",
  styleUrls: ["./generate-general-report.component.scss"],
})
export class GenerateGeneralReportComponent implements OnInit {
  public addForm: FormGroup;
  public clients: Prospect[] = [];
  public minDate: Date;
  public loader = false;
  public filteredOptions;
  public userData: UserData;
  public activeCycle: any = null;

  constructor(
    private companyService: ProspectsService,
    public ref: MatDialogRef<GenerateGeneralReportComponent>,
    private fb: FormBuilder,
    private router: Router,
    private reportService: ReporteService,
    private userService: UserService,
    private authService: AuthService,
    private billingService: BillingService
  ) { }

  async ngOnInit() {
    this.addForm = this.fb.group({
      start_date: [""],
      end_date: [""],
      client: [""],
      hasCalls: [true],
      clientActivities: [false],
      withOutAssistantName: [false],
      hasSchedule: [true],
    });

    const clientControl = this.addForm.get('client');

    if (clientControl) {
      clientControl.valueChanges.subscribe(async (client) => {

        if (!client || !client.uid) {
          this.activeCycle = null;
          return;
        }
        console.log("Cliente seleccionado:", client);
        await this.loadActiveCycle(client._id);
      });
    }

    this.userData = await this.getUserInfo()
    if (this.userData.tipo == "administrador") {
      this.clients = await this.getCompanies();
    } else {
      this.clients = await this.getUserCompanies(this.userData.nombre)
    }
    this.filteredTariff()
  }

  private async getUserInfo() {
    try {
      let currentUserId = this.authService.currentuser().uid;
      return await this.userService.getUserById(currentUserId);
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: 'Ocurrió un error al consultar la informacion del usuario',
        icon: 'error',
        text: "Si el problema persiste, favor de reportar el error"
      })
    }
  }

  private async getUserCompanies(name: string) {
    try {
      const response = await this.companyService.getActiveProspects()
      var clients = response.data.filter((prospect) =>
        prospect.assistant.includes(name) || prospect.ejecutivo.includes(name))
      return clients
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: 'Ocurrió un error al consultar los clientes usuario',
        icon: 'error',
        text: "Si el problema persiste, favor de reportar el error"
      })
    }
  }

  filteredTariff() {
    this.filteredOptions = this.addForm.controls['client'].valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
  }

  private normalizeText(text: string): string {
    return text
      ?.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') || '';
  }

  private _filter(value: any): Prospect[] {
    if (typeof value !== 'string') {
      return this.clients;
    }
    
    if (!value || value.trim() === '') {
      return this.clients;
    }
    
    const searchTerm = this.normalizeText(value);
    
    return this.clients.filter((client) => {
      const clientName = this.normalizeText(client.nombre);
      return clientName.includes(searchTerm);
    });
  }

  async loadActiveCycle(clientId: string) {
    try {

      const cycles = await this.billingService.getActiveCycles();

      const cycle = cycles.find(c => c.clientId === clientId);

      this.activeCycle = cycle || null;

    } catch (error) {
      console.error(error);
      this.activeCycle = null;
    }
  }

  displayFn(client: Prospect) {
    return client.nombre
  }

  async getCompanies() {
    try {
      var companies = await this.companyService.getActiveProspects();
      return companies.data.sort((a, b) => a.nombre > b.nombre ? 1 : -1)
    } catch (error) {
      await Swal.fire({
        icon: 'error',
        title: 'Ocurrió un error al obtener los clientes',
        text: "Si el problema persiste, favor de reportar el error"
      })
    }
  }

  onSelectedStartDate(event) {
    var date = new Date(event);
    date.setDate(date.getDate() + 1);
    this.minDate = new Date(event);
  }


  validateForm() {
    var form = this.addForm.value;
    if (form.client == "" || form.start_date == "" || form.end_date == "") {
      return Swal.fire({
        position: "center",
        icon: "error",
        title: "Todos los campos son obligatorios",
        showConfirmButton: true,
      });
    }
    this.action(form);
  }

  async action(form: any) {
    try {
      this.loader = true;
      var companyID = form.client.uid;
      var obj = {
        initDate: form.start_date.getTime(),
        endDate: form.end_date.getTime(),
        callReport: form.hasCalls,
        clientActivities: form.clientActivities,
        withOutAssistantName: form.withOutAssistantName,
      }
      var url = await this.reportService.createGeneralReport(companyID,obj)
      await Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Se ha generado el reporte correctamente',
        showConfirmButton: false,
        timer: 1500
      });
      this.ref.close();
      this.addForm.reset();
      this.loader = false;
      this.router.navigate(['reporte-general/', url])
    } catch (error) {
      this.ref.close();
      this.addForm.reset();
      this.loader = false;
      if (error.status == 504) {
        return Swal.fire({
          icon: 'error',
          title: "Ocurrió un error externo al servidor",
          text: "No se pudo acceder al servicio http://134.122.14.131:9020, para consultar informacion de las llamadas, si el problema persiste favor de ponerse en contacto con el area de TI de MIA"
        })
      } else {
        return Swal.fire({
          position: "center",
          icon: 'error',
          title: "Ocurrió un error al crear los datos",
          text: "Intente de nuevo más tarde",
          showConfirmButton: true,
        });
      }
    }
  }
}
